
import Vue from 'vue';
import { AxiosResponse } from 'axios';
import { $axios } from '@/utils/api';
import { routesNames } from '@/router';
import { distanceBetweenCoordinatesInKm } from '@/_helpers/misc_helper';

import MISC_DATA from '@/store/modules/MiscDataModule';
import UTILS from '@/store/modules/UtilityModule';

import PageHeader from '@/components/layout/PageHeader.vue';
import LocationList from '@/components/home/LocationList.vue';
import OfficialPartners from '@/components/home/OfficialPartners.vue';

export default Vue.extend({
	name: 'AllTrucks',

	components: { PageHeader, LocationList, OfficialPartners },

	mixins: [],

	async asyncData(context) {
		const domain = context.$getDomain();

		const all_landing_pages = await context.store.dispatch('GET_LANDING_PAGE_LIST', domain);

		return { all_landing_pages };
	},

	data() {
		return {
			google_api_key: this.$config.googleApiKey,
			nearest_locations: [] as any[],
			no_locations_msg: false,
			search_text: ''
		};
	},

	computed: {
		MISC_DATA: () => MISC_DATA,
		UTILS: () => UTILS,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		filteredLocations(): any[] {
			if (!this.search_text) {
				return this.all_landing_pages;
			}

			// .normalize('NFD').replace(/\p{Diacritic}/gu, '') -> this basically removes accents from string
			const search = this.search_text
				.trim()
				.toLowerCase()
				.replaceAll(/\s/gi, '')
				.normalize('NFD')
				.replace(/\p{Diacritic}/gu, '');

			const results = this.all_landing_pages.filter((lp: any) => {
				const lp_name = lp.name
					.toLowerCase()
					.trim()
					.replaceAll(/\s/gi, '')
					.normalize('NFD')
					.replace(/\p{Diacritic}/gu, '');
				return lp_name.includes(search);
			});

			return results;
		}

		// Use the Google map GEOCODING request using city name but add bounds (country or something at least) to filter out potential false results
		// eg. https://maps.googleapis.com/maps/api/geocode/json?address=Washington&bounds=36.47,-84.72%7C43.39,-65.90&key=
		// Also add the region (country) Eg. https://maps.googleapis.com/maps/api/geocode/json?address=Toledo&region=es&key=
	},

	watch: {
		filteredLocations() {
			// Empty the nearest location / msg
			this.nearest_locations = [];
			this.no_locations_msg = false;
		}
	},

	mounted() {
		// check if LP data is here otherwise redirect home
		if (this.all_landing_pages && this.all_landing_pages.length < 1) {
			this.$router.push({ name: routesNames.home });
		}
		this.UTILS.setPageLoader(false);
	},

	methods: {
		async getNearestLocations(): Promise<void> {
			if (!this.search_text) {
				return;
			}

			this.UTILS.setPageLoader(true);

			const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(this.search_text)}&region=${encodeURIComponent('at')}&key=${
				this.google_api_key
			}`;

			let input_coordinates: { lat: number; lng: number };

			try {
				const res = await $axios.get(url).then((res: AxiosResponse) => res.data);
				if (!res.results || res.results.length < 1) {
					this.no_locations_msg = true;
					this.UTILS.setPageLoader(false);
					return;
				}
				input_coordinates = res.results[0].geometry.location;
				// Get all the existing locations in a 100km radius around the user's input location
				const locations_in_100km_radius = this.all_landing_pages
					.map((lp: any) => {
						const lp_coordinates = lp.map.center;
						const dist = Math.ceil(distanceBetweenCoordinatesInKm({ coordinates_1: input_coordinates, coordinates_2: lp_coordinates }));
						if (dist <= 100) {
							return lp;
						}
						return undefined;
					})
					.filter(Boolean);
				// sort by distance
				const sorted = locations_in_100km_radius.sort((a: any, b: any) => a.distance - b.distance) as any;
				// assign first 5 location to nearest_locations
				this.nearest_locations = sorted.splice(0, 5);
			} catch (err) {
				console.error('GoogleAPI-Geocode failed', err);
			}

			if (this.nearest_locations.length < 1) {
				this.no_locations_msg = true;
			}

			this.UTILS.setPageLoader(false);
		},

		redirectToCzPartner(): void {
			window.open('https://location.123-transporter.cz', '_blank');
		}
	}
});
